const slugify = require('@sindresorhus/slugify')
const _ = require('lodash')

class Slugger {
  constructor() {
    this.reset()
  }

  slug(text, opts) {
    let slug = slugify(text, opts)
    const originalSlug = slug

    while (_.has(this.memory, slug)) {
      this.memory[slug] += 1
      slug = slugify(`${originalSlug}-${this.memory[slug]}`)
    }

    this.memory[slug] = 0
    return slug
  }

  reset() {
    this.memory = {}
  }
}

module.exports = Slugger
